import { Link } from "@inertiajs/react";
import { usePage } from "@inertiajs/react";
import { ArrowRight } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";


export default function CollectionsMegaMenu({
  open,
  onClose,
}) {
  const { navigation = {} } = usePage().props;
  const collectionsMegaMenu = navigation.collectionsMegaMenu ?? {
    columns: [],
    featured: null,
  };

  return (
    <AnimatePresence>
      {open && (
          <motion.div
          id="collections-mega-menu"
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.22, ease: "easeOut" }}
          className="absolute inset-x-0 top-full z-50 border-b border-rose-100 bg-[#fff7fa] text-slate-900 shadow-2xl shadow-black/10"
        >
          <div className="mx-auto w-full max-w-[1440px] px-4 sm:px-6 lg:px-8 ">
            <div className="grid gap-8 py-8 md:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1.3fr] lg:gap-10 lg:py-10">
              {collectionsMegaMenu.columns.map((column) => (
                <section key={column.id}>
                  <h2 className="text-lg font-black uppercase tracking-[0.08em] text-[#d80b67]">
                    {column.title}
                  </h2>

                  <nav
                    className="mt-5 flex flex-col items-start gap-3"
                    aria-label={column.title}
                  >
                    {column.items.map((item) => (
                      <Link
                        key={item.label}
                        href={item.href}
                        onClick={onClose}
                        className="text-sm font-medium text-slate-700 transition hover:translate-x-1 hover:text-[#d80b67] focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d80b67]"
                      >
                        {item.label}
                      </Link>
                    ))}

                    <Link
                      href={column.moreLink.href}
                      onClick={onClose}
                      className="mt-1 inline-flex items-center gap-1 border-b border-[#d80b67] pb-0.5 text-sm font-bold text-[#d80b67] transition hover:text-[#f51b75]"
                    >
                      {column.moreLink.label}
                      <ArrowRight className="size-3.5" />
                    </Link>
                  </nav>
                </section>
              ))}

              {collectionsMegaMenu.featured && (
                <FeaturedCollection
                  featured={collectionsMegaMenu.featured}
                  onClose={onClose}
                />
              )}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

function FeaturedCollection({ featured, onClose }) {
  return (
    <Link
      href={featured.href}
      onClick={onClose}
      className="group relative min-h-[320px] overflow-hidden rounded-[1.75rem] bg-slate-900 text-white shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d80b67] focus-visible:ring-offset-2 lg:min-h-[360px]"
    >
      <img
        src={featured.image}
        alt={featured.imageAlt}
        className="absolute inset-0 size-full object-cover transition duration-700 group-hover:scale-105"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-black/15" />

      <div className="absolute inset-x-0 bottom-0 p-6 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/60">
          {featured.eyebrow}
        </p>

        <h2 className="mt-3 text-3xl font-black uppercase tracking-tight">
          {featured.title}
        </h2>

        <span className="mt-5 inline-flex min-h-12 items-center justify-center rounded-full bg-white px-7 py-3 text-sm font-black uppercase text-black transition group-hover:-translate-y-1 group-hover:bg-rose-100">
          {featured.buttonLabel}
        </span>
      </div>
    </Link>
  );
}
